var map = {
	"./0.png": 293,
	"./1.png": 72,
	"./2.png": 361,
	"./3.png": 987,
	"./aegis.png": 427,
	"./coronacht.png": 935,
	"./exagryph.png": 880,
	"./heat.png": 587,
	"./malphon.png": 123,
	"./stygius.png": 792,
	"./varatha.png": 232
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;